import styles from 'widget/event_components/ticket-spot.scss';
import cn from 'classnames';
import { isEmpty, map } from 'lodash';
import getSymbolFromCurrency from 'currency-symbol-map';
import { DiscountedPrice } from 'widget/event_components/Ticket/components/DiscountPrice';
import { PriceValue } from 'widget/event_components/Ticket/components/PriceValue';
import * as E from './elements';

export const TicketCheckoutSummaryForm = ({ loadingCheckoutValues, checkoutValues, tickets, event, cart, settings, ticketOverrides }) => {
  const isRsvp = event.get('event_setup') === 'rsvp';

  return (
    <E.Wrapper>
      {isEmpty(cart) && settings.get('checkoutNoTicketsSelectedText') && (
        <div className={styles.emptyCart}>
          {/* <div className="cart-summary-header">{settings.get('checkoutTicketSummaryText')}</div> */}
          <span className="no-ticket-selected">{settings.get('checkoutNoTicketsSelectedText')}</span>
        </div>
      )}
      {map(cart, (quantity, ticketId) => {
        const ticket = tickets.find((t) => +t.get('id') === +ticketId);

        return (
          <E.Ticket className={`ticket-information ${window.isMobileType ? styles.mobileTicketInformation : ''}`}>
            <div className={styles.ticketItemQuantity}>{quantity}x</div>
            <div className={styles.ticketItemDescription}>{ticket.get('name')}</div>
            <div className={cn(styles.selection, styles.ticketItemInformations, { [styles.mobileSelection]: window.isMobileType })}>
              <>
                {settings.get('hideFreePriceLabel') || isRsvp ? null : (
                  <DiscountedPrice
                    ticket={ticket}
                    ticketOverrides={ticketOverrides}
                    currency={getSymbolFromCurrency(event.get('currency'))}
                    quantity={+quantity}
                  />
                )}
              </>
            </div>
          </E.Ticket>
        );
      })}
      {settings.get('hideCartSummary') || isRsvp ? null : (
        <div className={`${styles.cartSummary} ticket-price`}>
          {event.get('sales_tax') && event.get('sales_tax') > 0 ? (
            <E.TotalTextContainer>
              <E.TotalTitle>{settings.get('checkoutTicketSalesTaxText')}</E.TotalTitle>
              <PriceValue
                loadingCheckoutValues={loadingCheckoutValues}
                price={checkoutValues?.taxTotal}
                discount={0}
                currency={getSymbolFromCurrency(event.get('currency'))}
              />
            </E.TotalTextContainer>
          ) : null}
          {checkoutValues?.totalCustomBookingFees > 0 && (
            <E.TotalTextContainer>
              <div>{settings.get('checkoutBookingFeeTotalText')}</div>
              <PriceValue
                loadingCheckoutValues={loadingCheckoutValues}
                price={checkoutValues?.totalCustomBookingFees}
                discount={0}
                cartTotalBeforeDiscount={checkoutValues?.totalCustomBookingFees}
                currency={getSymbolFromCurrency(event.get('currency'))}
              />
            </E.TotalTextContainer>
          )}
          <E.TotalTextContainer>
            <E.TotalTitle className="checkout-total-text">{settings.get('checkoutTicketTotalText')}</E.TotalTitle>
            <PriceValue
              loadingCheckoutValues={loadingCheckoutValues}
              price={checkoutValues?.cartTotal}
              discount={checkoutValues?.discount}
              cartTotalBeforeDiscount={checkoutValues?.cartTotalBeforeDiscount}
              currency={getSymbolFromCurrency(event.get('currency'))}
              className="checkout-total-value"
            />
          </E.TotalTextContainer>
        </div>
      )}
    </E.Wrapper>
  );
};
